/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ScanFrameIcon16Regular = forwardRef('ScanFrameIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M14.75 4A2.75 2.75 0 0 0 12 1.25h-1.75a.75.75 0 0 0 0 1.5H12c.69 0 1.25.56 1.25 1.25v1.75a.75.75 0 0 0 1.5 0V4Z" }),
        React.createElement("path", { d: "M4 14.75A2.75 2.75 0 0 1 1.25 12v-1.75a.75.75 0 0 1 1.5 0V12c0 .69.56 1.25 1.25 1.25h1.75a.75.75 0 0 1 0 1.5H4Z" }),
        React.createElement("path", { d: "M12 14.75A2.75 2.75 0 0 0 14.75 12v-1.75a.75.75 0 0 0-1.5 0V12c0 .69-.56 1.25-1.25 1.25h-1.75a.75.75 0 0 0 0 1.5H12Z" }),
        React.createElement("path", { d: "M4 1.25A2.75 2.75 0 0 0 1.25 4v1.75a.75.75 0 0 0 1.5 0V4c0-.69.56-1.25 1.25-1.25h1.75a.75.75 0 0 0 0-1.5H4Z" })));
});
